export function upperCaseBegin(s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Returns 1 if a > b, 0 if equal and -1 if a < b
 * @param a string
 * @param b string
 */
export function compareStrings(a: string, b: string) {
    if (a === b) {
        return 0;
    }
    return a > b ? 1 : -1;
}
